export default __webpack_public_path__ + "locales/cs/Article.json?hash=38e35a3cd2714f19974732d87d4d8c35";